module.exports = __webpack_public_path__ + "img/thumbnail_WesternLowlandGorilla_f_albino.84c2a98a.png";